"use client"

import type { AlgoliaProductHit, AlgoliaPromoCardHit } from "~/lib/algolia/types"
import {
  isProductCardHit,
  isPromoCardHit,
} from "~/components/ui/AlgoliaCollectionGrid/AlgoliaListingGrid/_utils/check-hit-type"
import { ProductCardRevamped, type ProductCardRevampedProps } from "~/components/ui/ProductCardRevamped/index.client"
import { PromoCard } from "~/components/ui/PromoCard"

export function AlgoliaCardDispatcher({
  firstImageType,
  priority = false,
  ...hit
}: Pick<ProductCardRevampedProps, "priority" | "firstImageType"> & (AlgoliaProductHit | AlgoliaPromoCardHit)) {
  if (isProductCardHit(hit)) {
    return (
      <ProductCardRevamped
        trackAsAlgoliaConversion
        firstImageType={firstImageType}
        priority={priority}
        withSiblings
        {...hit}
      />
    )
  }

  if (isPromoCardHit(hit)) {
    return <PromoCard priority={priority} {...hit?.promoCard} />
  }

  return null
}
